import {
  SET_SELECTED_CITY,
  GET_CITIES,
  SET_CITIES,
  GET_CITIES_ERROR,
  SET_PARAM_CITY
} from './city.types';
import { AnyAction, Reducer } from 'redux';
import { CityState } from 'models/redux/city.state';

const initialState: CityState = {
  cities: [],
  selectedCity: undefined,
  loadingCities: false,
  paramCity: ''
};

const reducer: Reducer<CityState> = (
  state: CityState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case SET_PARAM_CITY:
    case SET_SELECTED_CITY:
      return { ...state, ...action.payload };

    case GET_CITIES:
      return { ...state, loadingCities: true };

    case SET_CITIES:
      return { ...state, ...action.payload, loadingCities: false };

    case GET_CITIES_ERROR:
      return { ...state, loadingCities: false };

    default:
      return state;
  }
};

export default reducer;
